import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                    padding: '20px',
                    backgroundColor: '#f8fafc',
                    color: '#1e293b'
                }}>
                    <div style={{
                        maxWidth: '500px',
                        padding: '40px',
                        background: 'white',
                        borderRadius: '12px',
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                    }}>
                        <h1 style={{ fontSize: '24px', marginBottom: '16px', color: '#ef4444' }}>Ojej! Coś poszło nie tak.</h1>
                        <p style={{ marginBottom: '24px', color: '#64748b' }}>
                            Wystąpił nieoczekiwany błąd aplikacji. Spróbuj odświeżyć stronę.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                padding: '10px 20px',
                                background: '#2563eb',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                fontWeight: '500'
                            }}
                        >
                            Odśwież stronę
                        </button>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <pre style={{
                                marginTop: '20px',
                                padding: '15px',
                                background: '#f1f5f9',
                                borderRadius: '6px',
                                overflow: 'auto',
                                fontSize: '12px',
                                textAlign: 'left',
                                color: '#ef4444'
                            }}>
                                {this.state.error.toString()}
                            </pre>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
